import React from "react";

import OverviewContainer from "../../../../../container/overview";
import { ESupplyChainOverviewTabs } from "../../../../../models/supply.chain.overview.configure";

const OrdersOverviewPanel = () => {
  return <OverviewContainer panel={ESupplyChainOverviewTabs.ORDERS} />;
};

export default OrdersOverviewPanel;
